import React, { useState } from 'react';

export interface NotionCollapsibleProps {
  title: string;
  count?: string | number;
  actions?: React.ReactNode[];
  children: React.ReactNode;
  defaultOpen?: boolean;
}

export const NotionCollapsible: React.FC<NotionCollapsibleProps> = ({
  title,
  count,
  actions,
  children,
  defaultOpen = false,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="border-t border-slate-200 py-3">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center gap-2 cursor-pointer hover:bg-slate-50/50 px-0 py-1 group transition-colors"
        aria-expanded={isOpen}
      >
        <span className="text-slate-400 group-hover:text-slate-600 transition-colors flex-shrink-0">
          {isOpen ? '▾' : '▸'}
        </span>
        <span className="font-semibold text-sm text-slate-900">{title}</span>
        {count !== undefined && (
          <span className="text-slate-500 text-sm font-normal">· {count}</span>
        )}
        {actions && actions.length > 0 && (
          <div className="ml-auto flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
            {actions.map((action, idx) => (
              <div key={idx}>{action}</div>
            ))}
          </div>
        )}
      </button>
      {isOpen && (
        <div className="mt-2 pl-6 pr-0 text-sm text-slate-600 leading-relaxed">
          {children}
        </div>
      )}
    </div>
  );
};
